export const markupRuleSelectors = {
  gridData: (state) => state.gridData,
  update: (state) => state.update,
}
